import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import s from './RowWrapper.scss';
const RowWrapper = /*#__PURE__*/ React.forwardRef((_param, innerRef)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        ref: innerRef,
        className: classnames(s['strip'], className)
    }, props));
});
RowWrapper.displayName = 'RowWrapper';
export default RowWrapper;
